$('[data-cancel-theme-preview]').on('click', function () {

    $.ajax({
        type: 'GET',
        url: $(this).data("cancelThemePreview"),
        complete: function () {
            location.href = '/';
        }
    });

});
